import React from 'react';

const ChessPage = () => (
  <div>
    <iframe id={"frame"} title={'chess'} src={"http://31.16.128.95:3000/"} style={{width: '100vw', height: '1200px', frameBorder: '0', border: 'none'}}/>
  </div>
)

export default ChessPage;